// Configuration for PDF table viewer grid lines feature
//
// Set USE_SERVER_SIDE_GRIDLINES to:
// - true: Use server-provided grid lines when available (recommended)
//   - Preserves table headers during word redistribution (headers from selectedTable.headers)
//   - Uses server's coordinate system (row 0 = first data row, headers separate)
//   - More accurate for complex table layouts
//   - Prevents cell merging and row loss issues
// - false: Always generate grid lines from cell bounds (legacy behavior)
//   - Headers may be redistributed during grid line changes
//   - Uses client-side coordinate system (row 0 = headers, row 1+ = data)
//   - Generates grid lines based on word positions
//
// This flag can be easily changed to toggle the feature across the entire PDF viewer

export const USE_SERVER_SIDE_GRIDLINES = true;

// Set COLUMN_ADDITION_MULTI_PAGE to:
// - true: Adding new columns (splitting) affects all pages of multi-page tables
// - false: Adding new columns is limited to the current page only
export const COLUMN_ADDITION_MULTI_PAGE = true;

// Set COLUMN_MOVEMENT_MULTI_PAGE to:
// - true: Moving existing vertical grid lines affects all pages of multi-page tables
// - false: Moving existing vertical grid lines only affects the current page
export const COLUMN_MOVEMENT_MULTI_PAGE = false;

// Set ENABLE_CIRCLE_DRAWING_TOOL to:
// - true: Show circle drawing tool in the navigation bar
// - false: Hide circle drawing tool
export const ENABLE_CIRCLE_DRAWING_TOOL = false;

// Set PDF_PAGE_CACHE_SIZE to:
// - Number of PDF pages to cache in memory for faster rendering
// - Higher values = more memory usage but faster page switching
// - Recommended: 50-200 depending on available memory
export const PDF_PAGE_CACHE_SIZE = 100;

// Set CONFIDENCE_FILTERING_ENABLED to:
// - true: Enable confidence-based text filtering in table display
// - false: Show all text regardless of confidence score
export const CONFIDENCE_FILTERING_ENABLED = true;

// Set DEFAULT_CONFIDENCE_THRESHOLD to:
// - Minimum confidence score (0-1) for displaying text
// - Text with confidence below this threshold will be filtered out
// - Recommended: 0.9 (90% confidence)
export const DEFAULT_CONFIDENCE_THRESHOLD = 0.9;

// CSV Export Naming Convention
// Template: {table_name}_cactus_{date}.csv
// - {table_name}: The selected table ID or name
// - {date}: Current date in YYYY-MM-DD format
export const CSV_EXPORT_NAMING = {
  prefix: "",
  suffix: "cactus",
  dateFormat: "YYYY-MM-DD", // ISO format
};
